'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recentLogins = require('../Services/recentLogins');

var _NavItemExpandable = require('./NavItemExpandable');

var _NavItemExpandable2 = _interopRequireDefault(_NavItemExpandable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NUM_MAX_LINKS = 5;

var RecentlyVisited = function (_Component) {
  _inherits(RecentlyVisited, _Component);

  function RecentlyVisited() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RecentlyVisited);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RecentlyVisited.__proto__ || Object.getPrototypeOf(RecentlyVisited)).call.apply(_ref, [this].concat(args))), _this), _this.state = { loaded: false, loading: false }, _this.loadRecentLogins = function () {
      if (_this.props.accessToken && !_this.state.loading && !_this.state.loaded) {
        _this.setState({ loading: true });
        (0, _recentLogins.getUserRecentLogins)(_this.props.accessToken).then(function (data) {
          if (!_this._isMounted) {
            return false;
          }
          _this.setState({ data: data, loaded: true, loading: false });
        });
      }
    }, _this.componentDidMount = function () {
      _this.loadRecentLogins();
      _this._isMounted = true;
    }, _this.componentWillUnmount = function () {
      _this._isMounted = false;
    }, _this.componentDidUpdate = function () {
      _this.loadRecentLogins();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RecentlyVisited, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          loaded = _state.loaded,
          data = _state.data;


      if (!this.props.accessToken) {
        return null;
      }

      var navItem = {
        id: 'recentlyVistited',
        text: 'Recently Visited',
        svg: 'rank-army-star-2-l',
        subItems: (data || []).slice(0, 4).map(function (loginItem) {
          return {
            id: loginItem.clientId,
            text: loginItem.title,
            url: loginItem.link
          };
        })
      };
      return _react2.default.createElement(_NavItemExpandable2.default, { item: navItem, isActive: true, key: navItem.id });
    }
  }]);

  return RecentlyVisited;
}(_react.Component);

exports.default = RecentlyVisited;
//# sourceMappingURL=recentlyVisited.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress-technology/react-platform-header/lib/Header/recentlyVisited.js
// module id = 572
// module chunks = 0